<template>
  <div class="qualifications wrapper">
    <p class="pub-title">荣誉资质</p>
    <p class="pub-sub-title">Honor</p>
    <swiper class="swiper" ref="swiper" v-if="list.length" :options="options">
      <swiper-slide v-for="(item, index) in list">
        <div class="box">
          <div class="top" @click="mask = index">
            <img :src="item.img" alt="" />
            <img src="../../assets/plus.png" class="plus" />
          </div>
          <div class="down">{{ item.title }}</div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="btns">
      <div class="btn" @click="swiper.slidePrev()">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="btn" @click="swiper.slideNext()">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="mask" v-if="mask !== -1" @click="mask = -1">
      <img :src="list[mask].img" alt="" />
    </div>
  </div>
</template>

<script>
import { honor } from '../../utils/api'
export default {
  data() {
    return {
      list: [],
      mask: -1,
      options: {
        slidesPerView: 4,
        spaceBetween: 40,
        centerInsufficientSlides: true,
      },
    }
  },
  created() {
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
      this.options.slidesPerView = 2
      this.options.spaceBetween = 17
    }
  },
  mounted() {
    honor((r) => {
      console.log(r.data.data)
      this.list = r.data.data
    })
  },
  computed: {
    swiper() {
      return this.$refs.swiper.swiper
    },
  },
}
</script>

<style lang="less" scoped >
.swiper {
  width: 100%;
}
.mask {
  z-index: 1111;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 1200px;
    max-height: calc(100vh - 16px);
  }
}
.wrapper {
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .pub-sub-title {
    margin-bottom: 40px;
  }
  .box:hover {
    background: white;

    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
  .box:hover::after {
    width: 100%;
  }
  .box::after {
    width: 0%;
    content: '';
    height: 4px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #097ad8;
    transition: all 0.15s linear;
  }
  .box {
    background: #f5f5f5;
    transition: all 0.15s linear;
    cursor: pointer;
    position: relative;
    .top {
      padding: 40px;
      box-sizing: border-box;
      position: relative;
      img {
        height: 262px;
        width: 100%;
      }
      .plus {
        width: 22px;
        height: 22px;
        position: absolute;
        bottom: 10px;
        right: 21px;
      }
    }
    .down {
      padding: 20px 0;
      border-top: 1px solid #c8c8c8;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 46px;
      color: #1a1a1a;
      margin: 0 auto;
      width: calc(100% - 40px);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
.btns {
  display: flex;
  margin-top: 40px;
}
.btn:first-child {
  margin-right: 80px;
}
.btn {
  width: 80px;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s linear;
  border-radius: 50%;
  font-size: 32px;
}
.btn:active {
  opacity: 0.78;
}
.btn:hover {
  background: #006C8F;
  color: white;
}
@media (max-width: 767px) {
  .wrapper {
    padding: 0.68rem 0.34rem;
    box-sizing: border-box;
    .box {
      .top {
        padding: 0.24rem;
        box-sizing: border-box;
        height: 3.72rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: unset;
          max-height: 100%;
          width: unset;
          max-width: 100%;
          display: block;
        }
      }
      .down {
        padding: 0.24rem 0;
        width: calc(100% - 0.48rem);
        font-size: 0.28rem;
        line-height: unset;
      }
    }
  }
  .btns {
    margin-top: 0.26rem;
    .btn {
      width: 0.92rem;
      height: 0.92rem;
      font-size: 0.48rem;
    }
  }
}
</style>